let types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  CHECKBOX: "checkbox",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  DATETIME_PICKER: "datetime_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA:"text_area",
  SPACE: "space",
  BUTTON: "button",
  EMAIL: "email"
}

export const filed_types = types


// WEBPACK FOOTER //
// ./src/constants/field_types.js